import { InvoiceItemData, ProviderDetails } from '../../../datasource';
import { AnimanaInvoiceItem } from './AnimanaInvoiceItem';
import { DatasourceFullSiteInfo } from '../../../datasource/sites';

export class AnimanaInvoiceItemWithVariantDetail extends AnimanaInvoiceItem {
    difference?: InvoiceItemData = {} as InvoiceItemData;

    providers: ProviderDetails[];

    sites?: DatasourceFullSiteInfo[];

    variants: AnimanaInvoiceItem[] = [];
}
